import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import MainLayout from './layouts/MainLayout';
import LoginView from './views/auth/LoginView';
import NotFoundView from './views/errors/NotFoundView';
import ParkingZoneListView from "./views/ParkingZone/List";
import ParkingZoneFormView from "./views/ParkingZone/Form";
import AuditLogListView from "./views/AuditLog/List";
import ParkingZoneGroupFormView from "./views/ParkingZoneGroup/Form";
import ParkingZoneGroupListView from "./views/ParkingZoneGroup/List";
import ParkingEventListView from "./views/ParkingEvent/List";
import ParkingPermitListView from "./views/ParkingPermit/List";
import FineListView from "./views/Fine/List";
import UserListView from "./views/User/List";
import UserFormView from "./views/User/Form";
import VerificationStatusView from "./views/Verification/Status";
import SettingFormView from "./views/Setting/Form";
import SettingListView from "./views/Setting/List";

const routes = [
	{
		path: 'app',
		element: <DashboardLayout />,
		children: [
			{ path: 'dashboard', element: <Navigate to="/app/fines" /> },
			{ path: 'parking-zones/new', element: <ParkingZoneFormView /> },
			{ path: 'parking-zones/:id', element: <ParkingZoneFormView /> },
			{ path: 'parking-zones', element: <ParkingZoneListView /> },
			{ path: 'parking-zone-groups/new', element: <ParkingZoneGroupFormView /> },
			{ path: 'parking-zone-groups/:id', element: <ParkingZoneGroupFormView /> },
			{ path: 'parking-zone-groups', element: <ParkingZoneGroupListView /> },
			{ path: 'parking-events', element: <ParkingEventListView /> },
			{ path: 'parking-permits', element: <ParkingPermitListView /> },
			{ path: 'fines', element: <FineListView /> },
			{ path: 'users/new', element: <UserFormView /> },
			{ path: 'users/:id', element: <UserFormView /> },
			{ path: 'users', element: <UserListView /> },
			{ path: 'settings/:id', element: <SettingFormView /> },
			{ path: 'settings', element: <SettingListView /> },
			{ path: 'audit-log', element: <AuditLogListView /> },
			{ path: 'verification-status', element: <VerificationStatusView /> },
			{ path: '*', element: <Navigate to="/404" /> }
		]
    },
	{
		path: '/',
		element: <MainLayout />,
		children: [
			{ path: 'login', element: <LoginView /> },
			{ path: '404', element: <NotFoundView /> },
			{ path: '/', element: <Navigate to="/login" /> },
			{ path: '*', element: <Navigate to="/404" /> }
		]
	}
];

export default routes;